module.exports = __webpack_public_path__ + "static/media/homeleftGreen.614027f8.png";